/* PG Joint Chrome
   DESTINATION: assets/pg-joint-chrome.js

   Moves the sticky CTA out to <body> so no transformed ancestor can re-base
   its position:fixed. The portal host carries the section scope classes, so
   the scoped CSS in pg-joint-chrome.css still matches after the move. */
(function () {
  'use strict';

  var HOST_CLASS = 'pgh-portal';
  var HOST_ATTR = 'data-pgh-portal-for';

  function removeStaleHosts(sectionId) {
    var stale = document.querySelectorAll('[' + HOST_ATTR + '="' + sectionId + '"]');
    Array.prototype.forEach.call(stale, function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
  }

  function init(root) {
    if (!root) return;

    var sectionId = root.getAttribute('data-pgh-section') || 'default';

    // A theme-editor re-render leaves the old portal behind. Clear it first.
    removeStaleHosts(sectionId);

    var src = root.querySelector('[data-pgh-sticky]');
    if (!src) return;

    var mode = src.getAttribute('data-pgh-mode') || 'sticky';
    var bar = src.querySelector('.pgh-sticky');
    if (!bar) return;

    // Static mode renders in place. Nothing to portal.
    if (mode !== 'sticky') return;

    // Editor needs to see and click the block where it lives.
    if (window.Shopify && window.Shopify.designMode) return;

    var offset = parseInt(src.getAttribute('data-pgh-offset'), 10);
    if (isNaN(offset)) offset = 600;

    var host = document.createElement('div');
    host.className = 'shopify-section section-pg-chrome ' + HOST_CLASS;
    host.setAttribute(HOST_ATTR, sectionId);
    host.appendChild(bar);
    document.body.appendChild(host);

    var visible = false;
    var ticking = false;

    function evaluate() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var atBottom =
        y + window.innerHeight >= (document.documentElement.scrollHeight || 0) - 4;
      var next = y > offset && !atBottom;
      if (next === visible) return;
      visible = next;
      host.classList.toggle('is-visible', visible);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(evaluate);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    evaluate();

    root.__pghCleanup = function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      removeStaleHosts(sectionId);
    };
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pgh-root]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-pgh-root]');
    if (root) init(root);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-pgh-root]');
    if (root && typeof root.__pghCleanup === 'function') root.__pghCleanup();
  });
})();